import axios from './axios-base';
import _ from 'lodash';
import { delay } from 'q';

// Try roughly for 10 minutes (600 times with a second wait in between attempts)
export const POLL_NUM_OF_RETRIES = 600;

//initially polling is on with this flag
let flag = false;

// Wait one second after a poll attempt has completed
export const POLL_INTERVAL_MS = 1000;

//expects fn() to throw if it failed
//if it runs out of retries, poll() will resolve to an rejected promise, containing the latest error
function poll(fn: any, retries = POLL_NUM_OF_RETRIES, timeoutBetweenAttempts = POLL_INTERVAL_MS): any {
  return Promise.resolve()
    .then(fn)
    .catch(function retry(err): any {
      if (retries-- > 0)
        return delay(timeoutBetweenAttempts)
          .then(fn)
          .catch(retry);
      throw err;
    });
}

/**
 * Poll tracking service for result.
 * @param requestId
 * @param retries number of retries (default 600)
 * @param timeoutBetweenAttempts timeout in millis
 * @param intermediateCallback optional function which is called between polling intervals
 */
export const pollTrackingService = (
  requestId: string,
  retries: number = POLL_NUM_OF_RETRIES,
  timeoutBetweenAttempts: number = POLL_INTERVAL_MS,
  intermediateCallback?: any,
): any => {
  return (async () => {
    return await poll(
      () =>
        axios.get(`/trackings/${requestId}`, {}).then(res => {
          intermediateCallback ? intermediateCallback(res) : _.noop();
          return validateTrackingServiceResult(res);
        }),
      retries,
      timeoutBetweenAttempts,
    );
  })();
};

export const pollTrackingServiceAndDispatchEvents = (
  requestId: string,
  validateResult: any,
  retries: number = POLL_NUM_OF_RETRIES,
  timeoutBetweenAttempts: number = POLL_INTERVAL_MS,
): any => {
  return (async () => {
    return await poll(
      () => axios.get(`/trackings/${requestId}`, {}).then(validateResult),
      retries,
      timeoutBetweenAttempts,
    );
  })();
};

function validateTrackingServiceResult(res: any) {
  if (!isFinished(res)) {
    throw res;
  }
  return res;
}

function isFinished(res: any) {
  return _.get(res, 'data.result.status', 'Unknown') === 'FINISHED';
}

export const pollTrackingServiceForLogs = (
  requestId: string,
  retries: number = POLL_NUM_OF_RETRIES,
  timeoutBetweenAttempts: number = POLL_INTERVAL_MS,
): any => {
  return (async () => {
    flag = false; //if user clicks again same link then it will start the polling again
    const result = await poll(
      () => axios.get(`/trackings/${requestId}`, {}).then(validateTrackingServiceResultLogs),
      retries,
      timeoutBetweenAttempts,
    );

    return isFinishedPollingLogs(result);
  })();
};

function validateTrackingServiceResultLogs(res: any) {
  if (!isFinishedPollingLogs(res)) {
    throw res;
  }
}

export const cancelPolling = () => {
  flag = true; //It stops the polling after clicking close button or clicking Cancel Button
};

function isFinishedPollingLogs(res: any) {
  if (flag) return true;
  return _.get(res, 'data.result.status', 'Unknown') === 'FINISHED';
}
